import { Services } from "appworks/services/services";
import { SoundEvent } from "appworks/services/sound/sound-events";
import { SoundService } from "appworks/services/sound/sound-service";
import { SoundNames } from "sounds-enum";

export function ThemeSoundSetup(): void {
    const soundService = Services.get(SoundService);

    for (let i = 1; i <= 9; i++) {
        soundService.registerPlay(`meter_boost${i}`, { id: `meter_boost${Math.min(i, 5)}` });
    }

    soundService.registerPlay("coins_start", { id: (SoundNames as any).big_win_coins_loop, loop: true, volume: 0.6 });
    soundService.registerStop("end_coins", { id: (SoundNames as any).big_win_coins_loop });
    soundService.registerPlay("big_win_fireworks_start", { id: (SoundNames as any).big_win_fireworks, loop: true });
    soundService.registerStop("big_win_fireworks_end", { id: (SoundNames as any).big_win_fireworks });
    soundService.registerPlay("reel_spin1", { id: (SoundNames as any).reel_spin1 });
    soundService.registerPlay("reel_spin2", { id: (SoundNames as any).reel_spin2 });
    soundService.registerPlay("reel_spin3", { id: (SoundNames as any).reel_spin3 });
    soundService.registerPlay("reel_spin4", { id: (SoundNames as any).reel_spin4 });
    soundService.registerStop("reel_spin_stop", { id: (SoundNames as any).reel_spin1 });
    soundService.registerPlay(SoundEvent.start_spin, { id: (SoundNames as any).reel_spin1 });
    soundService.eventOverrides.set("reel_0_spinner_stage_complete_fullstop", (SoundNames as any).reel_stop1);
    soundService.registerPlay("theme_reel_spin_stop", { id: (SoundNames as any).reel_stop1 });
    soundService.eventOverrides.set("reel_0_spinner_stage_complete_fullstop", "theme_reel_spin_stop");
    soundService.eventOverrides.set("reel_1_spinner_stage_complete_fullstop", "theme_reel_spin_stop");
    soundService.eventOverrides.set("reel_2_spinner_stage_complete_fullstop", "theme_reel_spin_stop");
    soundService.eventOverrides.set("reel_3_spinner_stage_complete_fullstop", "theme_reel_spin_stop");
    soundService.eventOverrides.set("reel_4_spinner_stage_complete_fullstop", "theme_reel_spin_stop");
    soundService.eventOverrides.set("reel_4_spinner_stage_complete_fullstopskip", "theme_reel_spin_stop");
    soundService.registerPlay("bonus_X_land", { id: (SoundNames as any).wild_marker3 });
    soundService.registerPlay("bonus_Y_land", { id: (SoundNames as any).wild_marker2 });
    soundService.registerPlay("bonus_Z_land", { id: (SoundNames as any).wild_marker1 });
    soundService.registerPlay("reel_1_anticipate_start", { id: (SoundNames as any).anticipation3 });
    soundService.registerPlay("reel_2_anticipate_start", { id: (SoundNames as any).anticipation3 });
    soundService.registerPlay("reel_3_anticipate_start", { id: (SoundNames as any).anticipation3 });
    soundService.registerPlay("reel_4_anticipate_start" , { id: (SoundNames as any).anticipation4 });
}